import { useCallback } from "react";
import Cookies from "js-cookie";
import type { Form } from "@/react/types/Form";

const COOKIE_PREFIX = "circle_modal_form_closed";

const cookieName = (formUid: string) => `${COOKIE_PREFIX}_${formUid}`;

const setCookie = (formUid: string, days: number): void => {
  // this will only work on secure (https) environments
  Cookies.set(cookieName(formUid), "true", {
    expires: days,
    sameSite: "None",
    secure: true,
  });
};

const checkCookie = (formUid: string): boolean =>
  Cookies.get(cookieName(formUid)) !== undefined;

interface UseModalCookieProps {
  form: Form;
  popupFrequency?: number;
}
export const useModalCookie = ({
  form,
  popupFrequency,
}: UseModalCookieProps) => {
  const shouldSuppressPopupForm = checkCookie(form.uid);
  const frequency = popupFrequency ?? form.popup_frequency;

  const suppressPopupForm = useCallback(() => {
    if (frequency === 0) return;
    setCookie(form.uid, frequency);
  }, [form, frequency]);
  return { shouldSuppressPopupForm, suppressPopupForm };
};
